<template>
  <div :id="random_id"
       :class="twMerge(['w-full relative' ,
           props.appendClass
       ])"
       :data-testid="props.dataTestid">
    <div class="relative mb-56 md:mb-32">
      <TsNewsletter :hasIcon="false"
                    :class="twMerge('flex flex-col items-center rounded-lg text-natural-grey dark:text-gray-400'
                    , props.backgroundColorClass)">
      </TsNewsletter>
      <div class="absolute mt-[-5rem] m-auto w-full justify-center items-center flex z-50">
        <TsImage style="width: 20rem" :class="imageClass" :src="imageUrl" loading="lazy"/>
      </div>
    </div>
    <div>

      <div
          :class="twMerge(['absolute border-1 bottom-0 w-full px-3 py-4 rounded-lg' ,
          'flex flex-col md:flex-row lg:flex-row xl:flex-row 2xl:flex-row justify-between',
          props.backgroundColorClass
          ])">
        <div
            class="flex items-center justify-center lg:flex-no-wrap md:flex-no-wrap flex-wrap xl:flex-nowrap 2xl:flex-nowrap flex-wrap">
          <p class="text-natural-grey dark:text-gray-400">
            <slot name="appDownloadMsg">
              {{ appDownloadMsg }}
            </slot>
          </p>
          <TsCardCta appendClass="ms-2 text-natural-grey dark:text-gray-400"></TsCardCta>
        </div>

        <div
            class="flex items-center justify-center lg:flex-no-wrap md:flex-no-wrap flex-wrap xl:flex-nowrap 2xl:flex-nowrap flex-wrap mt-3 md:mt-0 lg:mt-0 xl:mt-0 2xl:mt-0">

          <p v-if="props.paymentOptions" class="me-2 text-natural-grey dark:text-gray-400">
            <slot name="paymentMsg">
              {{ paymentMsg }}
            </slot>
          </p>
          <div class="flex gap-0.5 p-1">
            <slot name="paymentOptions">
              <TsImage v-for="url in props.paymentOptions" :src="url" :key="url" loading="lazy"/>
            </slot>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts" generic="T">
import {useRandomUUID} from "~/composables/useRandomUUID";
import {twMerge} from "tailwind-merge";
import {onMounted} from "vue";

const TsNewsletter = defineAsyncComponent(
    () => import('~/components/organisms/TsNewsletter.vue')
);

const TsCardCta = defineAsyncComponent(
    () => import('~/components/organisms/TsCardCta.vue')
);

type Props = {
  appendClass?: string;
  imageClass?: string;
  imageUrl?: string;
  backgroundColorClass?: string;
  dataTestid?: string;
  paymentMsg?: string;
  appDownloadMsg?: string;
  placeholder?: string;
  label?: string;
  paymentOptions?: string[];
};

const props = withDefaults(defineProps<Props>(), {
  imageUrl: '/images/newsTellerSection.png',
  imageClass: '',
  appendClass: '',
  backgroundColorClass: 'bg-[#eaecf9]',
  dataTestid: 'molecule-newstellersectioncard',
  paymentMsg: 'Secure payment',
  appDownloadMsg: 'Download the APP and get 5% OFF',
  placeholder: 'Email',
  label: 'Keep me updated about products, news, tips and offers.',
  paymentOptions: () => ['/images/logos/paypal.png',
    '/images/logos/mastercard.svg',
    '/images/logos/googlePay.png',
    '/images/logos/tradeAccount.svg'] as string[],
});

const random_id = ref('');
onMounted(() => {
  random_id.value = useRandomUUID();
});
</script>